/* Waïloa – header compact au défilement (logo mark) + curseur personnalisé.
   Léger, sans dépendance, chargé en defer. */
(function () {
  var header = document.querySelector('header[data-header-section]');
  var body = document.body;

  /* ---------- Header : logo mark au défilement ---------- */
  if (header && header.getAttribute('data-wl-compact') === 'true') {
    var on = false, ticking = false;
    var ON_AT = 120, OFF_AT = 40; /* hystérésis : pas de clignotement près du seuil */
    var update = function () {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      if (!on && y > ON_AT) { on = true; body.classList.add('wl-scrolled'); }
      else if (on && y < OFF_AT) { on = false; body.classList.remove('wl-scrolled'); }
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Méga menu : état ouvert/fermé annoncé aux lecteurs d'écran ---------- */
  document.querySelectorAll('.header__menus-item.has-megamenu > .header__menus-link').forEach(function (a) {
    var li = a.parentElement;
    var set = function (v) { if (a.getAttribute('aria-expanded') !== v) a.setAttribute('aria-expanded', v); };
    set('false');
    li.addEventListener('mouseenter', function () { set('true'); });
    li.addEventListener('mouseleave', function () { if (!li.contains(document.activeElement)) set('false'); });
    li.addEventListener('focusin', function () { set('true'); });
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) set('false'); });
  });

  /* ---------- Curseur ---------- */
  var wantCursor = header ? header.getAttribute('data-wl-cursor') === 'true' : false;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!wantCursor || !fine || reduce) return;

  var dot = document.createElement('div');
  dot.className = 'wl-cursor';
  dot.setAttribute('aria-hidden', 'true');
  body.appendChild(dot);
  document.documentElement.classList.add('wl-cursor-on');

  var LINKS = 'a, button, summary, label, select, [role="button"], [data-side-drawer-open], .swatch, input[type="checkbox"], input[type="radio"], input[type="submit"]';
  var FIELDS = 'input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea, [contenteditable="true"], iframe, video, .wl-cursor-off';
  var x = -100, y = -100, cx = -100, cy = -100, raf = null, visible = false;

  function loop() {
    cx += (x - cx) * 0.22;
    cy += (y - cy) * 0.22;
    dot.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
    if (Math.abs(x - cx) > 0.1 || Math.abs(y - cy) > 0.1) raf = requestAnimationFrame(loop);
    else raf = null;
  }
  document.addEventListener('mousemove', function (e) {
    x = e.clientX; y = e.clientY;
    if (!visible) { visible = true; cx = x; cy = y; dot.classList.add('is-visible'); }
    var t = e.target;
    var field = t.closest && t.closest(FIELDS);
    dot.classList.toggle('is-hidden', !!field);
    dot.classList.toggle('is-link', !field && !!(t.closest && t.closest(LINKS)));
    if (!raf) raf = requestAnimationFrame(loop);
  }, { passive: true });
  document.addEventListener('mousedown', function () { dot.classList.add('is-down'); });
  document.addEventListener('mouseup', function () { dot.classList.remove('is-down'); });
  document.documentElement.addEventListener('mouseleave', function () { visible = false; dot.classList.remove('is-visible'); });
  window.addEventListener('blur', function () { visible = false; dot.classList.remove('is-visible'); });
})();

/* Waïloa – menu mobile à onglets + vidéos courtes des vignettes (menu, collections, tuiles éditoriales). */
(function () {
  /* ---------- Menu mobile : onglets ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-wl-mm-tabs]').forEach(function (list) {
      if (list._wl) return; list._wl = true;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[data-wl-mm-tab]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) tab.focus();
        var l = tab.offsetLeft - 16;
        if (list.scrollTo) list.scrollTo({ left: Math.max(0, l), behavior: 'smooth' }); else list.scrollLeft = l;
        var box = list.closest('.wl-mm'); if (box) box.scrollTop = 0;
        try { sessionStorage.setItem('wl-mm-tab', tab.id); } catch (e) {}
        scan(document);
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = -1;
          if (k === 'ArrowRight') n = (i + 1) % tabs.length;
          else if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          else if (k === 'Home') n = 0;
          else if (k === 'End') n = tabs.length - 1;
          if (n > -1) { e.preventDefault(); select(tabs[n], true); }
        });
      });
      var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0];
      var saved = null; try { saved = sessionStorage.getItem('wl-mm-tab'); } catch (e) {}
      var hasActive = !!list.parentNode.querySelector('.wl-mm__panel [aria-current="page"]');
      if (saved && !hasActive) { var s = document.getElementById(saved); if (s && tabs.indexOf(s) > -1 && s !== cur) select(s, false); }
      else if (cur) list.scrollLeft = Math.max(0, cur.offsetLeft - 16);
    });
  }

  /* ---------- Vidéos : lecture muette en boucle seulement si visibles ---------- */
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  function allowed() {
    if (mqReduce && mqReduce.matches) return false;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return false;
    return true;
  }
  function play(v) {
    if (!allowed() || !v.isConnected) return;
    v.muted = true; v.playsInline = true;
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play();
    var on = function () { v.classList.add('is-on'); };
    if (p && p.then) p.then(on).catch(function () {}); else on();
  }
  function pause(v) { try { v.pause(); } catch (e) {} }
  function shown(v) {
    var el = v;
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none') return false;
      el = el.parentElement;
    }
    return true;
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && shown(v)) play(v); else pause(v);
    });
  }, { threshold: 0.35 }) : null;
  function scan(root) {
    (root || document).querySelectorAll('video[data-wl-vid]').forEach(function (v) {
      if (v._wl) { if (io) { io.unobserve(v); io.observe(v); } return; }
      v._wl = true;
      v.addEventListener('playing', function () { v.classList.add('is-on'); });
      var mega = v.closest('.header__megamenu');
      if (mega) {
        /* Méga menu ordinateur : lecture pendant l'ouverture du panneau seulement */
        var li = mega.closest('.header__menus-item');
        if (li && !li._wlv) {
          li._wlv = true;
          var vids = function () { return li.querySelectorAll('video[data-wl-vid]'); };
          var start = function () { setTimeout(function () { vids().forEach(function (x) { if (shown(x)) play(x); }); }, 180); };
          var stop = function () { vids().forEach(pause); };
          li.addEventListener('mouseenter', start);
          li.addEventListener('focusin', start);
          li.addEventListener('mouseleave', stop);
          li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) stop(); });
        }
        return;
      }
      if (io) io.observe(v);
    });
  }
  window.wlVidScan = scan;
  if (mqReduce && mqReduce.addEventListener) mqReduce.addEventListener('change', function () { if (mqReduce.matches) document.querySelectorAll('video[data-wl-vid]').forEach(pause); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) document.querySelectorAll('video[data-wl-vid]').forEach(pause); });

  /* Le menu mobile s'ouvre par transformation CSS : on relance la détection à l'ouverture */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-mobile-hamburger]')) setTimeout(function () { scan(document); }, 450);
  });

  function boot() { initTabs(document); scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); scan(e.target); });
  document.addEventListener('wl:products-rendered', function (e) { scan((e.detail && e.detail.root) || document); });
})();
